import type { Injector } from '@angular/core';
import { inject, runInInjectionContext } from '@angular/core';
import { assertInjector } from '@quipex/core/utils';
import { DialogService } from '@quipex/shared/ui';
import { PublishBuildingCheckoutDialog } from './publish-building-dialog';

export interface PublishBuildingDialogRequest {
    buildingId: string;
}

export interface PublishBuildingDialog {
    open: (request: PublishBuildingDialogRequest) => void;
}

export function injectPublishBuildingDialog(
    injector?: Injector
): PublishBuildingDialog {
    const resolvedInjector = assertInjector(
        injectPublishBuildingDialog,
        injector
    );

    const open = (request: PublishBuildingDialogRequest): void => {
        runInInjectionContext(resolvedInjector, () => {
            const dialogService = inject(DialogService);

            dialogService.openDialog(
                {
                    component: PublishBuildingCheckoutDialog,
                    componentInputs: {
                        buildingId: request.buildingId,
                    },
                },
                {
                    size: 'lg',
                    disableClose: false,
                    panelClass: [
                        'flex-content',
                        'no-padding',
                        'auto-h',
                        'publish-building-checkout',
                    ],
                }
            );
        });
    };

    return { open };
}
